export default __webpack_public_path__ + "static/media/earphones13.f54ed7cb.jfif";